import { mergeAttributes, Node, nodeInputRule } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import EmbedDocument from "./EmbedDocument.vue";

export default Node.create({
  name: "embedDocument",
  group: "block",
  atom: true,
  addAttributes() {
    return {
      documentId: null
    };
  },
  parseHTML() {
    return [
      {
        tag: "embed-document"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["embed-document", mergeAttributes(HTMLAttributes)];
  },
  addInputRules() {
    return [nodeInputRule({ find: /]]/g, type: this.type })];
  },
  addNodeView() {
    return VueNodeViewRenderer(EmbedDocument);
  }
});
